import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import Typography from '@mui/material/Typography';
import { Box, Paper, Stack, Skeleton } from '@mui/material';
import { IPieChartPanel } from '../Dashboard.model';
import { useMemo } from 'react';
import { LayoutItem } from 'react-grid-layout';

interface PieChartPanelProps {
  panel: IPieChartPanel;
  loading?: boolean;
  layout?: LayoutItem | undefined;
}
export function PieChartPanel(props: PieChartPanelProps) {
  const { panel, loading } = props;
  const loadingState = loading ?? panel.loading;
  const value = useMemo(
    () =>
      panel.series.reduce(
        (acc, item) => acc + item.data.reduce((sum, d) => sum + d.value, 0),
        0
      ),
    [panel.series]
  );
  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{ height: '100%', maxWidth: '100%', width: '100%' }}
    >
      {/* left column */}
      <Stack>
        {loadingState ? (
          <Skeleton variant="text" width={100} height={24} />
        ) : (
          <Typography
            variant="body1"
            fontWeight={800}
            fontSize={'0.8em'}
            maxWidth={100}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {panel.title}
          </Typography>
        )}
        {panel.subtitle && (
          <Typography variant="body2" color="text.secondary" fontSize={'0.6em'}>
            {panel.subtitle}
          </Typography>
        )}
        <Box
          sx={{
            alignItems: 'center',
            gap: 1,
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            mb: '1em!important',
          }}
        >
          {loadingState ? (
            <Skeleton variant="text" width={60} height={32} />
          ) : (
            <Typography
              variant="h3"
              component="div"
              sx={{ fontWeight: 'bold', marginX: 2 }}
            >
              {value}
            </Typography>
          )}
        </Box>
      </Stack>

      <Paper
        elevation={8}
        sx={{
          height: '100%',
          maxWidth: '100%',
          flex: 1,
          pt: 1,
          width: '100%',
          boxShadow: 'none',
        }}
      >
        {loadingState ? (
          <Skeleton variant="rectangular" width="100%" height={'100%'} />
        ) : (
          <PieChart
            series={panel.series}
            // sx={{ aspectRatio: '1.5 / 1', height: '100%', width: '100%' }}
            margin={0}
            slotProps={{
              legend: {
                direction: 'horizontal',
                position: {
                  vertical: 'bottom',
                  horizontal: 'center',
                },
              },
            }}
          />
        )}
      </Paper>
    </Stack>
  );
}

export default PieChartPanel;
